<template>
<div class="management-tasks page fixed-page">
  <div class="columns">
    <div class="column main-column">
      <div class="level page-header">
        <div class="level-left">
          <page-title :text="$t('global.tasks')" />
        </div>
        <div class="level-right">
          <div class="level-item">
            <button-simple
              class="level-item new-task-button"
              :text="$t('global.create_task')"
              icon="plus"
              @click="modals.isCreateGlobalTaskDisplayed = true"
            />
          </div>
        </div>
      </div>

      <management-task-list
        :tasks="taskList"
      />
    </div>

    <div
      id="side-column"
      class="column side-column"
      v-show="nbSelectedTasks > 0"
    >
      <task-info
        :task="selectedTasks.values().next().value"
        :singleTask="nbSelectedTasks === 1"
        @task-deleted="updateList()"
      />
    </div>

    <create-global-task-modal
      ref="create-global-task-modal"
      :active="modals.isCreateGlobalTaskDisplayed"
      :management="false"
      @cancel="modals.isCreateGlobalTaskDisplayed = false"
      @confirm="confirmCreateTask"
    />
  </div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { sortTasks } from '@/lib/sorting'
import ButtonSimple from '@/components/widgets/ButtonSimple'
import ManagementTaskList from '@/components/lists/ManagementTaskList'
import TaskInfo from '@/components/sides/TaskInfo.vue'
import PageTitle from '@/components/widgets/PageTitle'
import CreateGlobalTaskModal from '@/components/modals/CreateGlobalTaskModal.vue'

export default {
  name: 'global-tasks',

  components: {
    ButtonSimple,
    ManagementTaskList,
    TaskInfo,
    CreateGlobalTaskModal,
    PageTitle
  },

  data () {
    return {
      modals: {
        isCreateGlobalTaskDisplayed: false
      },
      taskList: []
    }
  },

  computed: {
    ...mapGetters([
      'taskTypeMap',
      'selectedTasks',
      'nbSelectedTasks',
      'taskMap'
    ])
  },

  methods: {
    ...mapActions([
      'loadGlobalTasks',
      'loadTask',
      'createGlobalTask'
    ]),

    confirmCreateTask ({ taskTypeId }) {
      var exists = false
      for (const task of this.taskList) {
        if (task.task_type.id === taskTypeId) {
          exists = true
          break
        }
      }
      if (!exists) {
        this.createGlobalTask(taskTypeId)
      }
      this.modals.isCreateGlobalTaskDisplayed = false
      this.updateList()
    },

    updateList () {
      this.taskList = []
      this.loadGlobalTasks()
        .then(tasks => {
          tasks.forEach(task => {
            if (task.level === 0) {
              this.loadTask({ taskId: task.id })
                .then(() => {
                  this.taskList.push(this.taskMap.get(task.id))
                    .then(() => {
                      this.taskList = sortTasks(this.taskList, this.taskTypeMap)
                    })
                })
            }
          })
        })
    }
  },

  mounted () {
    this.updateList()
  },

  metaInfo () {
    return {
      title: `${this.$t('global.tasks')} - Kitsu`
    }
  }
}
</script>

<style lang="scss" scoped>
.new-task-button {
  margin-right: 1em;
  color: #fff;
  background: #00AA3C;
}

.columns {
  height: 100%;
}

.side-column {
  margin-top: 0;
}
</style>
